import script from "./SearchResultItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultItems.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultItems.vue?vue&type=style&index=0&id=fe54e2ee&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe54e2ee"]])

export default __exports__